"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _polished = require("polished");
var _ = require("..");
var _utils = require("./utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var globalLight = {
  primaryColor: _.color.white,
  secondaryColor: _.color.black,
  primaryAccentColor: _.color.white,
  secondaryAccentColor: _.color.orange
};
var light = _objectSpread(_objectSpread({}, globalLight), {}, {
  color: globalLight.primaryColor,
  borderColor: globalLight.primaryColor,
  backgroundColor: globalLight.secondaryColor,
  header: {
    boxShadow: 'none',
    top: {
      color: globalLight.primaryColor,
      backgroundColor: 'transparent'
    },
    scroll: {
      color: globalLight.primaryColor,
      backgroundColor: globalLight.secondaryColor
    }
  },
  button: {
    backgroundColor: globalLight.primaryColor,
    color: globalLight.secondaryColor,
    ripple: (0, _polished.transparentize)(0.6, globalLight.secondaryColor)
  }
});
var globalDark = {
  primaryColor: _.color.black,
  secondaryColor: _.color.white,
  primaryAccentColor: _.color.white,
  secondaryAccentColor: _.color.orange
};
var dark = _objectSpread(_objectSpread({}, globalDark), {}, {
  color: globalDark.primaryColor,
  borderColor: globalDark.primaryColor,
  backgroundColor: globalDark.secondaryColor,
  header: {
    boxShadow: 'none',
    top: {
      color: globalDark.primaryColor,
      backgroundColor: 'transparent'
    },
    scroll: {
      color: globalDark.primaryColor,
      backgroundColor: globalDark.secondaryColor
    }
  },
  button: {
    backgroundColor: globalDark.primaryColor,
    color: globalDark.secondaryColor,
    ripple: (0, _polished.transparentize)(0.6, globalDark.secondaryColor)
  }
});
var globalAccent = {
  primaryColor: _.color.white,
  secondaryColor: _.color.darkBlue,
  primaryAccentColor: _.color.azure,
  secondaryAccentColor: _.color.orange
};
var accent = _objectSpread(_objectSpread({}, globalAccent), {}, {
  color: globalAccent.primaryColor,
  borderColor: globalAccent.primaryColor,
  backgroundColor: "linear-gradient(315deg, ".concat(_.color.purple, ", ").concat(_.color.azure, " 100%)"),
  header: {
    backgroundColor: 'transparent'
  },
  button: {
    backgroundColor: globalAccent.primaryColor,
    color: globalAccent.secondaryColor,
    ripple: (0, _polished.transparentize)(0.6, _.color.darkBlue)
  },
  form: {
    errorColor: globalAccent.secondaryAccentColor,
    accentColor: globalAccent.secondaryAccentColor,
    placeholderColor: (0, _polished.transparentize)(0.4, globalAccent.primaryColor)
  }
});
var _default = exports["default"] = (0, _utils.composeTheme)('black', {
  light: light,
  dark: dark,
  accent: accent
});